import { ThemedStyleFn } from '~src/hooks/useStyles';
import { fadeInKeyframes } from '~src/styles/animations';

export const styleFn: ThemedStyleFn = (theme) => ({
  outerEndAlignedIconWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'relative',
  },
  outerCenteredIconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
  },
  iconContainer: {
    width: 30,
    height: 30,
  },

  icons: {
    color: theme.colors.secondary,
    fontSize: '20px',
    margin: '0 2px',
  },
  small: {
    fontSize: '16px',
  },
  table: {
    '.ant-table-row': {
      animation: `${fadeInKeyframes} 0.3s ease-out`,
      cursor: 'pointer',

      '&.unfinished > td': {
        color: 'rgba(0, 0, 0, 0.25)',
      },
    },
  },
  actionsContainer: {
    display: 'flex',
    position: 'absolute',
    right: '50px',
    top: '0',
  },
  questionsButtonContainer: {
    position: 'absolute',
    right: '50px',
    bottom: '100px',
  },
  actionsRightButton: {
    marginBottom: 0,
    marginLeft: 2,
  },
  buttonDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    type: 'button',
    cursor: 'pointer',
    marginLeft: 4,
    padding: '2px 10px',
    ':hover': {
      backgroundColor: theme.colors.gray,
      borderRadius: 9,
    },
  },
  iconsHeader: {
    fontSize: '20px',
    color: theme.colors.primary,
    transition: '0.3s',
  },
  dotIcon: {
    marginRight: 0,
    fontSize: '20px',
    color: theme.colors.text.secondary,
  },

  tagPoint: {
    width: 15,
    height: 15,
    borderRadius: 10,
  },

  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '10px 20px',
  },

  // tag color-related styles
  yellow: {
    backgroundColor: theme.colors.yellow,
  },
  green: {
    backgroundColor: theme.colors.green,
  },
  lightGray: {
    backgroundColor: theme.colors.lightGray,
  },
  gray: {
    backgroundColor: theme.colors.gray,
  },
  red: {
    backgroundColor: theme.colors.red,
  },
  black: {
    backgroundColor: theme.colors.darkGray,
  },
  transparent: {
    border: `1px solid ${theme.colors.lightGray}`,
  },
});
